import { DataBean } from "../DataBean";


export class FunctionalID extends DataBean {

    public async getFunctionalIDByKey(idlnsite: number): Promise<any> {
        return this.getCustomService("OrangeBase", "com.orange.bean.functional.FunctionalID_getFunctionalIDByKey_Number", [idlnsite]);
    }

    public async getFunctionalIDByCode(jsonCode: string): Promise<any> {
        return this.getCustomService("OrangeBase", "com.orange.bean.functional.FunctionalID_getFunctionalIDByCode_String", [jsonCode]);
    }

    public async getIDBossByIDLnFunctionalID(idlnFunctionalID: number, idAccount: number): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.shared.DataBean_getIDBossByIDLnFunctionalID_Number_Number", [idlnFunctionalID, idAccount]);
    }

    public async importAccountToWorkGroup(idEmployee: number, media: string, mediaContext: string): Promise<any> {
        return this.getCustomService("CacheOptions",
            "java.util.List_importAccountToWorkGroup_Number_String_String",
            [idEmployee, media, mediaContext]);
    }

}